import { ImSpinner8 } from "react-icons/im"
import PopupBackground from "../popup-background"

export default function PopupSendOrder(props: {
  visibility: boolean
  loadingVisibility: boolean
  onPositiveClick: () => void
  onNegativeClick: () => void
}) {
  return (
    <PopupBackground visibility={props.visibility} id={""}>
      <form className="flex flex-col items-center h-fit max-w-2xl bg-white w-full rounded-2xl border border-[#E6E6E6]">
        <div className="flex flex-col items-center flex-1 py-3">
          <h1 className="text-3xl font-semibold underline">
            Závazně odeslat objednávku
          </h1>
          <h2 className="px-5 pt-3 text-center">
            Odesláním objednávky potvrzujete, že jste si vědomi všech podmínek
            nákupu, včetně způsobu platby, dodání a případného vrácení zboží.
            Uvedené údaje jsou správné a objednávku odesíláte závazně. Pokud
            máte jakékoli dotazy, kontaktujte nás před dokončením objednávky.
          </h2>
        </div>
        <div className="flex flex-row items-center justify-center w-full py-5 gap-x-5 h-fit">
          {props.loadingVisibility && (
            <ImSpinner8
              size={30}
              style={{ color: "gray" }}
              className="animate-spin"
            />
          )}
          {!props.loadingVisibility && (
            <>
              <button
                className="h-10 px-10 text-lg font-medium text-white bg-green-700 hover:font-semibold hover:bg-green-800 rounded-2xl"
                type="button"
                onClick={props.onPositiveClick}
              >
                Závazně objednat
              </button>
              <button
                type="button"
                className="h-10 px-10 text-lg font-medium text-white bg-red-700 hover:font-semibold hover:bg-red-800 rounded-2xl"
                onClick={props.onNegativeClick}
              >
                Zpět
              </button>
            </>
          )}
        </div>
      </form>
    </PopupBackground>
  )
}
